import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import * as MemberService from '../../api/memberService';
import * as StampCardService from '../../api/stampCardService';

import useNavContext from '../../hooks/useNavContext';
import useStampCardContext from '../../hooks/useStampCardContext';

import Spinner from '../../components/Spinner';

interface RouteParams {
  merchantId: string;
}

/**
 * Merchant
 */
export default function JoinMerchantScreen() {
  const selectedStampCard = useStampCardContext();
  const { merchantId } = useParams<RouteParams>();

  const [isLoading, setIsLoading] = useState(true);
  const [stampCardList, setStampCardList] = useState<
    StampCardService.StampCard[]
  >([]);
  const history = useHistory();

  const nav = useNavContext();
  nav?.removeNav();

  useEffect(() => {
    const join = async (merchantId: string) => {
      if (isLoading && selectedStampCard) {
        try {
          const resMember = await MemberService.join(merchantId);

          if (resMember) {
            setTimeout(async () => {
              const resStampCard = await StampCardService.listByMerchantId(
                merchantId
              );

              if (resStampCard && resStampCard.length > 0) {
                setStampCardList(resStampCard);
                selectedStampCard.setStampCard({
                  selectedStampCardId: resStampCard[0].id,
                  selectedSlotNumber: resStampCard[0].slotNumber,
                  selectedStampCampaignId: resStampCard[0].loyalty_campaign.id,
                });
                setIsLoading(false);
              } else {
                selectedStampCard.setStampCard({
                  selectedStampCardId: '',
                  selectedSlotNumber: 0,
                  selectedStampCampaignId: '0',
                });
                setIsLoading(false);
              }
            }, 1500);
          }
        } catch (e) {
          console.log('Error: joining merchant as member');
        }
      }
    };

    const checkMembership = async () => {
      if (merchantId && isLoading && selectedStampCard) {
        try {
          const resMember = await MemberService.get(merchantId);

          if (resMember) {
            const resStampCard = await StampCardService.listByMerchantId(
              merchantId
            );

            if (resStampCard) {
              if (resStampCard.length > 0) {
                selectedStampCard.setStampCard({
                  selectedStampCardId: resStampCard[0].id,
                  selectedSlotNumber: resStampCard[0].slotNumber,
                  selectedStampCampaignId: resStampCard[0].loyalty_campaign.id,
                });
                setIsLoading(false);
              } else {
                selectedStampCard.setStampCard({
                  selectedStampCardId: '',
                  selectedSlotNumber: 0,
                  selectedStampCampaignId: '0',
                });
                setIsLoading(false);
              }
            }
          }
        } catch (e) {
          console.log('No membership');
          join(merchantId);
        }
      }
    };

    if (merchantId) {
      checkMembership();
    }
  }, [merchantId, history, isLoading, selectedStampCard]);

  useEffect(() => {
    if (!isLoading) {
      setInterval(() => {
        history.replace(`/merchant/${merchantId}`);
        history.go(0);
      }, 1000);
    }
  }, [isLoading, history, merchantId, stampCardList, selectedStampCard]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 200,
      }}
    >
      {isLoading && <Spinner />}
    </div>
  );
}
